// src/admin/components/OrderGroupCard.js (Tam ve Güncel Kod)

import React, { useState } from 'react';
import axios from 'axios';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';
import Button from 'react-bootstrap/Button';
import Badge from 'react-bootstrap/Badge';
import ListGroup from 'react-bootstrap/ListGroup';
import Spinner from 'react-bootstrap/Spinner';
import BatchPdfGenerationModal from './BatchPdfGenerationModal';
import OrderDetailsModal from './OrderDetailsModal';
import PdfGenerationModal from './PdfGenerationModal'; // YENİ: Tekli PDF modalını da import et

const statusMap = {
    0: { text: 'Cancelled', bg: 'danger' },
    1: { text: 'Pending', bg: 'secondary' },
    2: { text: 'Send to Test', bg: 'info' },
    3: { text: 'Send to Print', bg: 'warning' },
    4: { text: 'Shipped', bg: 'success' },
};

function OrderGroupCard({ group, onRefresh, apiBaseUrl }) {
    const [isBatchModalOpen, setBatchModalOpen] = useState(false);
    const [isDetailsModalOpen, setDetailsModalOpen] = useState(false);
    const [isSendingAllToPrint, setIsSendingAllToPrint] = useState(false);

    // YENİ: Tekli PDF modalı için state'ler
    const [isSinglePdfModalOpen, setSinglePdfModalOpen] = useState(false);
    const [orderForSinglePdf, setOrderForSinglePdf] = useState(null);

    const firstOrder = group.orders[0];
    const canSendAllToTest = group.orders.every(o => String(o.order_status) === '1');
    const canSendAllToPrint = group.orders.every(o => String(o.order_status) === '2');

    const handleSendAllToPrint = async (orderGroup) => { /* ... öncekiyle aynı ... */
        const total = orderGroup.orders.length;
        if (!window.confirm(`Are you sure you want to send all ${total} orders in this group to the printer?`)) {
            return;
        }
        setIsSendingAllToPrint(true);
        try {
            for (const order of orderGroup.orders) {
                const formData = new URLSearchParams();
                formData.append('orderId', order.id);
                await axios.post(`${apiBaseUrl}/index.php?action=sendToPrinter`, formData);
            }
            alert(`${total} order(s) sent to the printer successfully!`);
            onRefresh();
        } catch (error) {
            console.error("Failed to send the batch to printer:", error);
            alert(`An error occurred: ${error.response?.data?.error || 'Could not send all orders to the printer.'}`);
        } finally {
            setIsSendingAllToPrint(false);
        }
    };
    
    // YENİ: Sipariş sayısına göre doğru modalı açan fonksiyon
    const handleSendToTestClick = () => {
        if (group.orders.length > 1) {
            setBatchModalOpen(true);
        } else if (group.orders.length === 1) {
            setOrderForSinglePdf(group.orders[0]);
            setSinglePdfModalOpen(true);
        }
    };

    return (
        <>
            {/* GRUP BAŞLIĞI */}
            <Row className="g-3 mb-3 pb-3 border-bottom align-items-center">
                <Col>
                    <h5 className="mb-1">Order Group #{group.baseOrderId}</h5>
                    <p className="mb-0 small"><strong>Customer:</strong> {firstOrder.parent_name} ({firstOrder.mail_adress})</p>
                </Col>
                <Col md="auto" className="text-md-end d-flex gap-2">
                    {canSendAllToTest && (
                        // GÜNCELLENDİ: Artık yeni fonksiyonu çağırıyor
                        <Button variant="primary" size="sm" onClick={handleSendToTestClick}>
                            Send All to Test ({group.orders.length})
                        </Button>
                    )}
                    {canSendAllToPrint && ( /* ... öncekiyle aynı ... */
                        <Button variant="success" size="sm" disabled={isSendingAllToPrint} onClick={() => handleSendAllToPrint(group)}>
                            {isSendingAllToPrint ? ( <><Spinner as="span" animation="border" size="sm" /> Sending...</> ) : `Send All to Print (${group.orders.length})`}
                        </Button>
                    )}
                    <Button variant="outline-info" size="sm" onClick={() => setDetailsModalOpen(true)}>
                        Order Details & Manage
                    </Button>
                </Col>
            </Row>

            {/* GRUP İÇİNDEKİ SİPARİŞLER (Butonsuz, sade liste) */}
            <ListGroup variant="flush">
                {group.orders.map(order => {
                    const statusInfo = statusMap[order.order_status] || { text: 'Unknown', bg: 'light' };
                    return (
                        <ListGroup.Item key={order.id} className="px-0">
                            <Row className="g-2 align-items-center">
                                <Col xs="auto"><Image src={order.image_urls[0]} rounded style={{ width: '50px', height: '50px', objectFit: 'cover' }} /></Col>
                                <Col>
                                    <p className="mb-0 fw-bold">{order.display_name}</p>
                                    <p className="mb-0 text-muted small">Sub-Order: ...{order.order_id.slice(-4)} &bull; {order.product_name}</p>
                                </Col>
                                <Col xs="auto" className="text-end"><Badge bg={statusInfo.bg} pill>{statusInfo.text}</Badge></Col>
                            </Row>
                        </ListGroup.Item>
                    );
                })}
            </ListGroup>

            {/* Modallar */}
            <BatchPdfGenerationModal show={isBatchModalOpen} orders={group.orders} onHide={() => setBatchModalOpen(false)} onSuccess={() => { setBatchModalOpen(false); onRefresh(); }} apiBaseUrl={apiBaseUrl} />
            <OrderDetailsModal show={isDetailsModalOpen} onHide={() => setDetailsModalOpen(false)} group={group} onRefresh={onRefresh} apiBaseUrl={apiBaseUrl} />
            
            {/* YENİ: Tekli PDF modalı render alanı */}
            {orderForSinglePdf && (
                <PdfGenerationModal
                    show={isSinglePdfModalOpen}
                    order={orderForSinglePdf}
                    onHide={() => setSinglePdfModalOpen(false)}
                    onSuccess={() => {
                        setSinglePdfModalOpen(false);
                        onRefresh();
                    }}
                    apiBaseUrl={apiBaseUrl}
                />
            )}
        </>
    );
}

export default OrderGroupCard;